// extracted by mini-css-extract-plugin
export default {"nativeInput":"FileUploader_nativeInput__RnQFv","label":"FileUploader_label__HdQxu","iconWrap":"FileUploader_iconWrap__wFcVN"};